import React, { RefObject } from 'react';
import { useFormContext } from 'react-hook-form';

import { Icon } from '@sravni/react-design-system';
import { Col, Row } from '@sravni/react-design-system/lib/Grid';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { EyeOff } from '@sravni/react-icons';
import { useIsPhone, useStyles } from '@sravni/react-utils';

import { useIsUserLogged } from '../../../../../store/hooks/users';
import { DATE_MASK, PHONE_MASK } from '../../../../../utils/validation';
import { FormControl } from '../../../../UI/FormControl';
import { TUserChangeHandler } from '../../../../UI/FormControl/types';
import { REVIEW_FIELDS } from '../../../constants/common';
import { Step } from '../Step/Step';
import { UploadFiles } from '../UploadFiles/UploadFiles';

import styles from './extra-info.module.scss';

type TExtraInfoProps = {
  extraInfoRef: RefObject<HTMLDivElement>;
  isReadOnly: boolean;
  handleUserChange?: TUserChangeHandler;
  commonEventLabel: string[];
};

export const ExtraInfoStep: React.FC<TExtraInfoProps> = (props) => {
  const { extraInfoRef, isReadOnly, handleUserChange, commonEventLabel } = props;

  const cx = useStyles(styles);
  const isPhone = useIsPhone();
  const isUserLogged = useIsUserLogged();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Step title={'Дополнительная информация'} className={'h-mt-8'} ref={extraInfoRef}>
      <div className={cx('exploration')}>
        <Icon icon={<EyeOff />} size={24} color={'blue'}></Icon>
        <Text size={14}>
          Эта часть не публикуются на сайте. Её{'\u00A0'}видите только вы, представитель организации и{'\u00A0'}Сравни.
          Эта информация может помочь решить вашу проблему или подтвердить сведения из{'\u00A0'}вашего отзыва
        </Text>
      </div>

      <div className={cx('greyWrapper', 'h-mt-24')}>
        <Row gutter={[24, 16]} className={cx('row')}>
          <Col span={isPhone ? 12 : 4}>
            <FormControl
              controlType="text"
              name={REVIEW_FIELDS.USER_NAME}
              control={control}
              label={'ФИО полностью'}
              error={errors?.[REVIEW_FIELDS.USER_NAME]}
              background={'light'}
              disabled={isReadOnly}
              handleUserChange={handleUserChange}
            />
          </Col>
          <Col span={isPhone ? 12 : 4}>
            <FormControl
              controlType="mask"
              name={REVIEW_FIELDS.USER_PHONE}
              control={control}
              label={'Номер телефона'}
              mask={PHONE_MASK}
              error={errors?.[REVIEW_FIELDS.USER_PHONE]}
              background={'light'}
              disabled={isReadOnly}
              handleUserChange={handleUserChange}
            />
          </Col>
          <Col span={isPhone ? 12 : 4}>
            <FormControl
              controlType="mask"
              name={REVIEW_FIELDS.BIRTHDAY}
              control={control}
              label={'Дата рождения'}
              mask={DATE_MASK}
              error={errors?.[REVIEW_FIELDS.BIRTHDAY]}
              background={'light'}
              disabled={isReadOnly}
              handleUserChange={handleUserChange}
            />
          </Col>
          <Col span={12}>
            <FormControl
              controlType="textarea"
              name={REVIEW_FIELDS.MESSAGE_FOR_COMPANY}
              control={control}
              label={
                'Любые подробности, например: номер договора и дата заключения, имя сотрудника, участвовавшего в ситуации'
              }
              error={errors?.[REVIEW_FIELDS.MESSAGE_FOR_COMPANY]}
              background={'light'}
              fieldClassName={cx('messageForCompany')}
              disabled={isReadOnly}
              handleUserChange={handleUserChange}
            />
          </Col>
          {isUserLogged && (
            <Col span={12} className={'h-mt-12'}>
              <UploadFiles isReadOnly={isReadOnly} commonEventLabel={commonEventLabel} />
            </Col>
          )}
        </Row>
      </div>
    </Step>
  );
};
